// The Deaths table's column-visibility toggle. Its one optional column is Created by, which is always
// offered and defaults off. Pure, no Vue dependency - same shape as
// `pigsStatusRecords/useStatusColumnVisibility.ts`. The generic mechanics (storage, toggling,
// select-all) live in the shared `useColumnVisibilityOverrides` composable instead.

/** The one column a reader can show or hide. Other columns are not part of this toggle. */
export type DeathsToggleColumnId = 'created_by';

/** Left-to-right table order of the mutable columns - just the one. */
export const TOGGLE_COLUMN_IDS: readonly DeathsToggleColumnId[] = ['created_by'];
